import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ratePost } from "../../redux/actions/postActions";
import formatCount from "../../utils/formatCount";
import StarsRating from "../rating/StarsRating";

export const RatingBtn = ({ id, ratings, className = "" }) => {
  const { data } = useSelector((state) => state.currentProfile);
  const dispatch = useDispatch();
  const safeRatings = Array.isArray(ratings) ? ratings : [];
  const [localRatings, setLocalRatings] = useState(safeRatings);
  const [userRating, setUserRating] = useState(
    safeRatings.find((r) => r.user?._id === data?._id)?.value || null,
  );

  useEffect(() => {
    const safeRatings = Array.isArray(ratings) ? ratings : [];
    setLocalRatings(safeRatings);
    setUserRating(
      safeRatings.find((r) => r.user?._id === data?._id)?.value || null,
    );
  }, [ratings, data?._id]);

  const rate = (value) => {
    if (!data?._id) return;

    const updatedRatings = localRatings.filter((r) => r.user?._id !== data._id);
    updatedRatings.push({ user: { _id: data._id }, value });

    setLocalRatings(updatedRatings);
    setUserRating(value);

    dispatch(ratePost({ id, data: { value } }));
  };

  const averageRating =
    localRatings.length > 0
      ? (
          localRatings.reduce((acc, r) => acc + r.value, 0) /
          localRatings.length
        ).toFixed(1)
      : "0.0";

  return (
    <div
      className={`flex flex-row items-center rating-bar ${className}`}
      onClick={(e) => e.stopPropagation()}
      style={{ gap: "5px" }}
    >
      <StarsRating
        rating={userRating || 0}
        onRatingChange={rate}
        size="small"
      />
      <div
        className="rating-text flex flex-row items-center"
        style={{ gap: "3px" }}
      >
        {averageRating !== "0.0" && (
          <span className="rating-text-1">{averageRating}</span>
        )}
        {localRatings.length ? (
          <span className="rating-text-2 text-gray-500">
            ({formatCount(localRatings.length)})
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default RatingBtn;
